<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <div class="mb-3">
      <h4>Reporte de Pacientes por Sexo</h4>
    </div>
    <hr>
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button
        v-for="atajo in atajos" :key="atajo.key"
        class="btn btn-sm" :class="atajo.clase"
        @click="aplicarAtajo(atajo)"
      >{{ atajo.label }}</button>
    </div>
    <div class="input-group mb-3">
      <span class="input-group-text">Desde</span>
      <input type="date" v-model="fechaDesde" class="form-control">
      <span class="input-group-text">Hasta</span>
      <input type="date" v-model="fechaHasta" class="form-control">
      <button
        class="btn btn-dark"
        @click="generarReporte"
        :disabled="!fechaDesde || !fechaHasta || cargando"
      >
        <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
        Consultar
      </button>
      <button
        class="btn btn-success"
        @click="exportToCSV"
        :disabled="!datos.length"
      >
        <span class="material-symbols-outlined align-middle" style="font-size:16px">download</span>
        CSV
      </button>
    </div>

    <div v-if="datos.length">
      <!-- KPIs -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Total atenciones</div>
            <div class="kpi-value">{{ totalAtenciones.toLocaleString() }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">Total pacientes</div>
            <div class="kpi-value">{{ totalPacientes.toLocaleString() }}</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">% Femenino (atenciones)</div>
            <div class="kpi-value">{{ pctFemenino }}%</div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="kpi-card">
            <div class="kpi-label">% Masculino (atenciones)</div>
            <div class="kpi-value">{{ pctMasculino }}%</div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="tabs">
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'tabla' }" @click="vistaActiva = 'tabla'">
          <span class="material-symbols-outlined" style="font-size:17px">table_view</span>
          Tabla
        </button>
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'grafico1' }" @click="vistaActiva = 'grafico1'">
          <span class="material-symbols-outlined" style="font-size:17px">pie_chart</span>
          Atenciones
        </button>
        <button class="tablink" :class="{ 'active-tab': vistaActiva === 'grafico2' }" @click="vistaActiva = 'grafico2'">
          <span class="material-symbols-outlined" style="font-size:17px">donut_large</span>
          Pacientes
        </button>
      </div>

      <!-- ── TABLA ── -->
      <div v-if="vistaActiva === 'tabla'" class="mt-3">
        <table class="table table-bordered table-hover table-sm">
          <thead class="table-dark">
            <tr>
              <th class="sortable" @click="ordenar('label')">
                Sexo
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'label' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end sortable" @click="ordenar('atenciones')">
                Atenciones
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'atenciones' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end">% Atenciones</th>
              <th class="text-end sortable" @click="ordenar('pacientes')">
                Pacientes
                <span class="material-symbols-outlined sort-icon">
                  {{ sortKey === 'pacientes' ? (sortDir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </span>
              </th>
              <th class="text-end">% Pacientes</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in filasSorted" :key="index">
              <td>{{ row.label }}</td>
              <td class="text-end">{{ row.atenciones }}</td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <div class="pct-bar-wrap">
                    <div class="pct-bar pct-bar--blue" :style="{ width: porcentaje(row.atenciones, totalAtenciones) + '%' }"></div>
                  </div>
                  {{ porcentaje(row.atenciones, totalAtenciones) }}%
                </div>
              </td>
              <td class="text-end">{{ row.pacientes }}</td>
              <td class="text-end">
                <div class="d-flex align-items-center justify-content-end gap-2">
                  <div class="pct-bar-wrap">
                    <div class="pct-bar pct-bar--teal" :style="{ width: porcentaje(row.pacientes, totalPacientes) + '%' }"></div>
                  </div>
                  {{ porcentaje(row.pacientes, totalPacientes) }}%
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td>Totales</td>
              <td class="text-end">{{ totalAtenciones }}</td>
              <td class="text-end">100%</td>
              <td class="text-end">{{ totalPacientes }}</td>
              <td class="text-end">100%</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- ── GRÁFICO ATENCIONES ── -->
      <div v-if="vistaActiva === 'grafico1'" class="mt-3">
        <apexchart
          type="pie"
          :options="chartAtenciones"
          :series="seriesAtenciones"
          height="400"
        />
      </div>

      <!-- ── GRÁFICO PACIENTES ── -->
      <div v-if="vistaActiva === 'grafico2'" class="mt-3">
        <apexchart
          type="pie"
          :options="chartPacientes"
          :series="seriesPacientes"
          height="400"
        />
      </div>
    </div>

    <div v-else-if="consultado" class="alert alert-info mt-3">
      No hay datos para el período seleccionado.
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import VueApexCharts from 'vue3-apexcharts'
import api           from '@/services/api'
import {
  getToday, getThisWeek, getThisMonth,
  getThisQuarter, getThisSemester, getThisYear,
} from '@/modules/queryDateUtils.js'

const LABEL = cod => cod === 'F' ? 'Femenino' : 'Masculino'

export default {
  name: 'ReportePacientesPorSexo',
  components: { Layout, Footer, apexchart: VueApexCharts },
  data() {
    return {
      fechaDesde:  '',
      fechaHasta:  '',
      datos:       [],
      vistaActiva: 'tabla',
      cargando:    false,
      consultado:  false,
      sortKey:     'atenciones',
      sortDir:     'desc',
      atajos: [
        { key: 'hoy',       label: 'Hoy',             clase: 'btn-outline-primary',   fn: getToday        },
        { key: 'semana',    label: 'Semana actual',    clase: 'btn-outline-danger',    fn: getThisWeek     },
        { key: 'mes',       label: 'Mes actual',       clase: 'btn-outline-secondary', fn: getThisMonth    },
        { key: 'trimestre', label: 'Trimestre actual', clase: 'btn-outline-success',   fn: getThisQuarter  },
        { key: 'semestre',  label: 'Semestre actual',  clase: 'btn-outline-info',      fn: getThisSemester },
        { key: 'anio',      label: 'Año actual',       clase: 'btn-outline-warning',   fn: getThisYear     },
      ],
    }
  },
  computed: {
    // filas normalizadas con label legible
    filas() {
      return this.datos.map(i => ({
        label:      LABEL(i[0]),
        atenciones: i[1],
        pacientes:  i[2],
      }))
    },
    filasSorted() {
      return [...this.filas].sort((a, b) => {
        const av = a[this.sortKey]
        const bv = b[this.sortKey]
        if (av < bv) return this.sortDir === 'asc' ? -1 : 1
        if (av > bv) return this.sortDir === 'asc' ? 1 : -1
        return 0
      })
    },
    totalAtenciones() {
      return this.filas.reduce((s, r) => s + r.atenciones, 0)
    },
    totalPacientes() {
      return this.filas.reduce((s, r) => s + r.pacientes, 0)
    },
    pctFemenino() {
      const f = this.filas.find(r => r.label === 'Femenino')
      return f ? this.porcentaje(f.atenciones, this.totalAtenciones) : 0
    },
    pctMasculino() {
      const m = this.filas.find(r => r.label === 'Masculino')
      return m ? this.porcentaje(m.atenciones, this.totalAtenciones) : 0
    },
    // ── Gráficos ──
    labels() {
      return this.filas.map(r => r.label)
    },
    seriesAtenciones() {
      return this.filas.map(r => r.atenciones)
    },
    seriesPacientes() {
      return this.filas.map(r => r.pacientes)
    },
    chartAtenciones() {
      return {
        chart:    { type: 'pie', toolbar: { show: false }, fontFamily: 'inherit' },
        labels:   this.labels,
        colors:   ['#e83e8c', '#0d6efd'],
        legend:   { position: 'bottom', fontSize: '13px' },
        tooltip:  { y: { formatter: (v) => `${v.toLocaleString()} atenciones (${((v / this.totalAtenciones) * 100).toFixed(1)}%)` } },
        responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: 'bottom' } } }],
      }
    },
    chartPacientes() {
      return {
        chart:    { type: 'pie', toolbar: { show: false }, fontFamily: 'inherit' },
        labels:   this.labels,
        colors:   ['#e83e8c', '#0d6efd'],
        legend:   { position: 'bottom', fontSize: '13px' },
        tooltip:  { y: { formatter: (v) => `${v.toLocaleString()} pacientes (${((v / this.totalPacientes) * 100).toFixed(1)}%)` } },
        responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: 'bottom' } } }],
      }
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    aplicarAtajo(atajo) {
      const { fechaDesde, fechaHasta } = atajo.fn()
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.generarReporte()
    },
async generarReporte() {
  if (!this.fechaDesde || !this.fechaHasta) return
  this.cargando   = true
  this.consultado = false
  try {
    const idEmpresa = window.sessionStorage.getItem('idEmpresa')
    
    // Cambio: usar /por-fecha en lugar de /contar-por-sexo
    const { data } = await api.get('/vwatencions/por-fecha', {
      params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
    })

    // Agrupar por sexo en el frontend
    const agrupado = {}
    for (const atencion of (data ?? [])) {
      const sexo = atencion.sexoPaciente ?? 'DESCONOCIDO'
      if (!agrupado[sexo]) {
        agrupado[sexo] = { atenciones: 0, pacientes: new Set() }
      }
      agrupado[sexo].atenciones++
      if (atencion.idPersona) {
        agrupado[sexo].pacientes.add(atencion.idPersona)
      }
    }

    // Convertir al formato Object[] que espera el componente: [sexo, atenciones, pacientes]
    this.datos = Object.entries(agrupado).map(([sexo, val]) => [
      sexo,
      val.atenciones,
      val.pacientes.size,
    ])

  } catch (error) {
    console.error('Error al obtener los datos:', error)
    this.datos = []
  } finally {
    this.cargando   = false
    this.consultado = true
  }
},
    ordenar(key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortDir = key === 'label' ? 'asc' : 'desc'
      }
    },
    porcentaje(valor, total) {
      if (!total) return 0
      return ((valor / total) * 100).toFixed(1)
    },
    exportToCSV() {
      const filas = [
        ['Sexo', 'Número de Atenciones', '% Atenciones', 'Número de Pacientes', '% Pacientes'],
        ...this.filas.map(r => [
          r.label,
          r.atenciones,
          `${this.porcentaje(r.atenciones, this.totalAtenciones)}%`,
          r.pacientes,
          `${this.porcentaje(r.pacientes, this.totalPacientes)}%`,
        ]),
        ['Totales', this.totalAtenciones, '100%', this.totalPacientes, '100%'],
      ]
      const csv  = filas.map(f => f.join(',')).join('\n')
      const blob = new Blob([csv], { type: 'text/csv' })
      const url  = URL.createObjectURL(blob)
      const a    = Object.assign(document.createElement('a'), {
        href: url, download: 'Reporte_Pacientes_Por_Sexo.csv',
      })
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>
/* ── KPIs ── */
.kpi-card {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 14px 18px;
  text-align: center;
}
.kpi-label {
  font-size: 0.75rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: .04em;
  margin-bottom: 4px;
}
.kpi-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0d6efd;
  line-height: 1.1;
}
/* ── Tabs ── */
.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid #dee2e6;
}
.tablink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  background: transparent;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px 6px 0 0;
  transition: all 0.2s ease;
}
.tablink:hover  { color: #0d6efd; background: #f0f4ff; }
.active-tab     { color: #0d6efd; border-bottom-color: #0d6efd; background: #fff; font-weight: 600; }
/* ── Tabla ── */
.sortable { cursor: pointer; user-select: none; white-space: nowrap; }
.sortable:hover { background: #495057; }
.sort-icon { font-size: 14px; vertical-align: middle; opacity: .7; }
/* Barras de porcentaje duales */
.pct-bar-wrap {
  width: 60px;
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
}
.pct-bar {
  height: 100%;
  border-radius: 3px;
  transition: width 0.4s ease;
}
.pct-bar--blue { background: #0d6efd; }
.pct-bar--teal { background: #20c997; }
</style>